import script from "./WCCouponClipButtonModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCCouponClipButtonModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCCouponClipButtonModern.vue?vue&type=style&index=0&id=4f3c56f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f3c56f2"]])

export default __exports__